import { getAppEnv } from './get-app-env';

export function isLocalEnvironment(): boolean {
  return getAppEnv() === 'local';
}

export function isDevEnvironment(): boolean {
  return getAppEnv() === 'dev';
}

export function isStagingEnvironment(): boolean {
  return getAppEnv() === 'stg';
}

export function isProductionEnvironment(): boolean {
  return getAppEnv() === 'prod';
}
